module.exports = __webpack_public_path__ + "static/media/integrity.c850ebfc.jpg";